import { CrudFilters } from "../../../../hooks/useCrudFilters";
import { useTranslation } from "react-i18next";
import { Button, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../hooks/useTypedSelector";
import { getAllEntityNames } from "../../infrastructure/slices/logSlice/logSlice";
import {
  TableFilterInputWrapper,
  TableFilters,
} from "../../../general/table/modules/commons/tableFilters/tableFilters";
import { TableFiltersWrapper } from "../../../general/table/modules/commons/tableFilters/tableFilters";

export const LogTableFilters = ({
  updateFilter,
  removeFilter,
  getFilter,
  filters,
  resetFilters,
}: CrudFilters) => {
  const { t } = useTranslation("common");
  const dispatch = useAppDispatch();

  const [allEntityNames, setAllEntityNames] = useState<string[]>([]);

  useEffect(() => {
    const fetchAllEntityNames = async () => {
      const entityNames = (await dispatch(
        getAllEntityNames(),
      ).unwrap()) as string[];
      setAllEntityNames(entityNames);
    };

    if (!allEntityNames.length) {
      void fetchAllEntityNames();
    }
  }, []);

  const subjectSearchValue = getFilter("subject_type", "contains") as string;
  const actionSearchValue = getFilter("event", "contains") as string;
  const causerSearchValue = getFilter("causer.username", "contains") as string;

  const createdAtGreaterThanOrEqual = getFilter(
    "created_at",
    "greaterThanOrEqual",
  ) as string;
  const createdAtLessThanOrEqual = getFilter(
    "created_at",
    "lessThanOrEqual",
  ) as string;

  const [dateSearchValue, setDateSearchValue] = useState<string>("");
  const [toggleBefore, setToggleBefore] = useState(
    createdAtLessThanOrEqual ? false : true,
  );

  return (
    <TableFiltersWrapper>
      <TableFilters>
        <TableFilterInputWrapper md={3}>
          <label>{t("Search by entity")}</label>
          <Form.Select
            id={"subject_type"}
            name={"subject_type"}
            value={subjectSearchValue ?? ""}
            onChange={(event) => {
              const value = event.target.value;
              if (value === "") {
                removeFilter("subject_type");
              } else {
                updateFilter("subject_type", value, "contains");
              }
            }}
          >
            <option value="">{t("All")}</option>
            {allEntityNames &&
              allEntityNames.map((entityName) => (
                <option key={entityName} value={entityName.toLowerCase()}>
                  {t(entityName)}
                </option>
              ))}
          </Form.Select>
        </TableFilterInputWrapper>

        <TableFilterInputWrapper md={3}>
          <label>{t("Search by event")}</label>
          <Form.Control
            type="text"
            placeholder={t("Search by event")}
            value={actionSearchValue ?? ""}
            onChange={(event) => {
              const value = event.target.value;
              if (value === "") {
                removeFilter("event");
              } else {
                updateFilter("event", value, "contains");
              }
            }}
          />
        </TableFilterInputWrapper>

        <TableFilterInputWrapper md={3}>
          <label>{t("Search by causer")}</label>
          <Form.Control
            type="text"
            placeholder={t("Search by causer")}
            value={causerSearchValue ?? ""}
            onChange={(event) => {
              const value = event.target.value;
              if (value === "") {
                removeFilter("causer.username");
              } else {
                updateFilter("causer.username", value, "contains");
              }
            }}
          />
        </TableFilterInputWrapper>

        <TableFilterInputWrapper md={3}>
          <label className="position-relative">
            {t("Search by date")}{" "}
            <Button
              size={"sm"}
              style={{
                marginLeft: "10px",
                marginBottom: "3px",
                fontSize: "10px",
                padding: "1px 9px",
                position: "absolute",
                top: "-4px",
                right: "0",
              }}
              variant={toggleBefore ? "secondary" : "primary"}
              onClick={() => {
                const newToggleBefore = !toggleBefore;
                setToggleBefore(newToggleBefore);
                if (dateSearchValue) {
                  removeFilter("created_at");
                  updateFilter(
                    "created_at",
                    dateSearchValue,
                    newToggleBefore ? "greaterThanOrEqual" : "lessThanOrEqual",
                  );
                }
              }}
            >
              {toggleBefore ? t("After") : t("Before")}
            </Button>
          </label>

          <Form.Control
            type="date"
            value={`${createdAtGreaterThanOrEqual?.replace(" 00:00:00", "") ?? createdAtLessThanOrEqual?.replace(" 00:00:00", "") ?? ""}`}
            onChange={(event) => {
              const value = event.target.value;
              if (value === "") {
                removeFilter("created_at");
              } else {
                removeFilter("created_at");
                updateFilter(
                  "created_at",
                  value + " 00:00:00",
                  toggleBefore ? "greaterThanOrEqual" : "lessThanOrEqual",
                );
                setDateSearchValue(value + " 00:00:00");
              }
            }}
          />
        </TableFilterInputWrapper>
      </TableFilters>
      {filters?.fields && Object.keys(filters.fields).length > 0 && (
        <Button
          onClick={resetFilters}
          size={"sm"}
          className="reset-filters"
          variant="light"
        >
          {t("Reset filters")}
        </Button>
      )}
    </TableFiltersWrapper>
  );
};
